import { render, staticRenderFns } from "./BrandBannerWidget.vue?vue&type=template&id=12f6b09d"
import script from "./BrandBannerWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./BrandBannerWidget.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BrandBannerWidget.vue?vue&type=style&index=0&id=12f6b09d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports